<h2 mat-dialog-title>{{ person.firstName }} {{ person.lastName }} ({{ person.email }})</h2>
<div mat-dialog-content>
  <table class="table">
    <thead>
      <tr>
        <th scope="col">Category</th>
        <th scope="col">Status</th>
        <th scope="col">Requires approval</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Shipments</td>
        <td>
          @if (isLoadingShipments) {
            Checking...
          } @else if (shipmentsCheckFailed) {
            Unable to determine
          } @else if (hasShipments) {
            Has shipments
          } @else {
            No shipments
          }
        </td>
        <td>
          @if (isLoadingShipments) {
            Checking...
          } @else if (shipmentsCheckFailed || hasShipments) {
            Yes
          } @else {
            No
          }
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</div>
